module.exports = __webpack_public_path__ + "69cafb30086c64c0c04924280a7c120c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-s.png
// module id = 110
// module chunks = 0